import { render } from "./IncidencesTable.vue?vue&type=template&id=30e378c8"
import script from "./IncidencesTable.vue?vue&type=script&lang=js"
export * from "./IncidencesTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src618844026/src/meta-page-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__